(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const logoImages = document.querySelectorAll('.blog-post-content img[src*="logo"]');

    logoImages.forEach(img => {
      
      const w = img.getAttribute('width');
      const h = img.getAttribute('height');

      if (w) img.style.width = w + 'px';
      if (h) img.style.height = h + 'px';

      img.style.maxWidth = 'none';
      img.style.display = 'inline-block';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
